import { CmsImageProps } from '../../../components/CmsImage';
import { RequiredResponsiveSizes } from '../../../components/CmsImage/generateSizesAttribute';
import { CmsImage } from '../../../types/cmsTypes';

// Header and footer logos are 24 px tall on phones (h-6) and 32 px from 768 px up (h-8); their
// width follows the aspect ratio. The header grows at 640 px, so between 640 and 767 px `sizes`
// says 24 px for a 32 px logo - the copy picked there is at most one step smaller.
const LOGO_HEIGHT = { phone: 24, wide: 32 };
// The sidebar logo's box, used when Strapi gives no dimensions.
const FALLBACK_ASPECT_RATIO = 104 / 32;

/**
 * `width` / `height` reserve the logo's box before the file loads, and `sizes` is the logo's
 * real width per breakpoint, so `CmsImage` offers a size-prefixed upload's small copies and the
 * browser picks the one that covers that width at the screen's density.
 */
export const getLogoImageSizing = (
  logo: Pick<CmsImage, 'width' | 'height'>,
): Pick<CmsImageProps, 'width' | 'height'> & {
  sizes: RequiredResponsiveSizes;
} => {
  const aspectRatio =
    logo.width && logo.height
      ? logo.width / logo.height
      : FALLBACK_ASPECT_RATIO;
  const widthAt = (height: number) => Math.round(height * aspectRatio);
  return {
    width: widthAt(LOGO_HEIGHT.wide),
    height: LOGO_HEIGHT.wide,
    sizes: { _: widthAt(LOGO_HEIGHT.phone), sm: widthAt(LOGO_HEIGHT.wide) },
  };
};
